require('./js/core');
require('./js/feature');
require('./js/panel');
require('./js/autoplay');
require('./js/container-reels');
require('./js/container-pays');
require('./js/container-pays-utils');
require('./js/container-messaging');
require('./js/container-anticipation');
require('./js/recall');
require('./js/utils');

require('./css/core.css');
require('./css/help.css');
require('./css/reels.css');
require('./css/messaging.css');
require('./css/anticipation.css');
require('./css/feature.css');
require('./css/panel.css');



/** WEBPACK FOOTER **
 ** ./../../public-src/common/common.js
 **/